import { arrawDown, dashboard, hcps, hospital, menu, question, static_content, staticStrings } from "../assets/Icons/icons";
import { adminLogo, profile } from "../assets/img/image";
import { strings } from "../strings/strings";

import DashboardLayout from "./DashboardLayout";

const adminMenu = [
  {
    title: strings.dashboard,
    icon: <img src={dashboard} className="w-5 h-5" alt="" />,
    path: "/country/dashboard",
  },
  {
    title: strings.staticStrings,
    icon: <img src={staticStrings} className="w-5 h-5" alt="" />,
    path: "/country/static-strings",
  },
  {
    title: strings.staticContent,
    icon: <img src={static_content} className="w-5 h-5" alt="" />,
    path: "/country/static-content",
  },
  {
    title: strings.question,
    icon: <img src={question} className="w-5 h-5" alt="" />,
    path: "/country/questions",
  },
  {
    title: strings.hospital,
    icon: <img src={hospital} className="w-5 h-5" alt="" />,
    path: "/country/hospitals",
  },
  {
    title: strings.hcps,
    icon: <img src={hcps} className="w-5 h-5" alt="" />,
    path: "/country/hcps",
  },
];

const CountryAdminLayout = () => {
  return (
    <DashboardLayout
      menuItems={adminMenu}
      logo={{ main: adminLogo, menu, dropdown: arrawDown }}
      profileImg={profile}
      roleName={strings.admin}
    />
  );
};

export default CountryAdminLayout;
